import React from 'react';
import './styles.css';
import PropTypes from 'prop-types';

const ButtonStep = ({ name, onClick, color }) => (
  <button
    onClick={onClick}
    type="button"
    style={{
      color: color.text,
      background: color.button,
      border: `1px solid ${color.border}`,
    }}
    className="buttons-step"
  >
    {name}
  </button>
);

ButtonStep.propTypes = {
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  color: PropTypes.object.isRequired,
};

export default ButtonStep;
